import angular from 'angular';

angular.module('cloudX').directive('cxGenderXedit', [
  function() {
    return {
      restrict: 'E',
      template:
        '<a href="#" editable-select="value" onbeforesave="save({newValue:$data})" e-ng-options="item.key as item.label for item in items" edit-disabled="disabled">' +
        '<span ng-show="value===\'M\'" data-translate>Male</span><span ng-show="value===\'F\'" data-translate>Female</span><span ng-show="value===\'N\'" data-translate>Non-binary</span><i class="glyphicon glyphicon-pencil" ng-show="!value"></i>' +
        '</a>',
      scope: {
        value: '=data',
        save: '&',
        disabled: '=?',
      },
      controller: [
        '$scope',
        '$rootScope',
        '$translate',
        function($scope, $rootScope, $translate) {
          function mapOptions() {
            $scope.items = [
              {
                key: 'M',
                label: $translate.instant('Male'),
              },
              {
                key: 'F',
                label: $translate.instant('Female'),
              },
              {
                key: 'N',
                label: $translate.instant('Non-binary'),
              },
            ];
          }

          mapOptions();
          var deregistration = $rootScope.$on('$translateChangeSuccess', mapOptions);
          $scope.$on('$destroy', deregistration);
        },
      ],
    };
  },
]);
